import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppDownloadSection from '../../components/AppDownloadSection/AppDownloadSection';
import './Policy.css';

const faqs = [
  {
    q: 'What is Cloud Kitchen?',
    a: 'A Cloud Kitchen is a delivery-only kitchen that has no physical dining space. It focuses solely on preparing and delivering food directly to customers through online ordering. Digirasa operates as a modern cloud kitchen, enabling us to maintain high food quality and faster delivery without the overhead of a traditional restaurant.',
  },
  {
    q: 'What types of food do you offer?',
    a: 'Digirasa offers a wide variety of healthy, home-style meals inspired by traditional South Indian and North Indian cuisines. Our rotating menu includes breakfast items, rice dishes, curries, dals, chapatis, thalis, snacks, and desserts — all prepared with fresh, quality ingredients.',
  },
  {
    q: 'How do I place an order?',
    a: 'You can place an order through our mobile app (available on Google Play and the App Store). Simply browse the menu, select your dishes, choose a delivery slot, and pay securely. You can also contact us directly at +91 81432 31857.',
  },
  {
    q: 'Do you offer meal plans for regular customers?',
    a: 'Yes! We offer flexible meal subscription plans — 1 Month, 2 Months, and 3 Months. These plans include 52 curated dishes per month with doorstep delivery. The 2-month and 3-month plans include free delivery and greater savings per meal.',
  },
  {
    q: 'Are your meals suitable for people with dietary restrictions?',
    a: 'Our meals are primarily vegetarian and designed to be nutritious and balanced. Many dishes can be customized to suit specific dietary requirements. Our menu is developed in consultation with dietitians and nutritionists. Please mention your dietary needs when ordering and we will do our best to accommodate them.',
  },
  {
    q: 'How do you ensure the quality and safety of the food?',
    a: 'We follow strict food safety and hygiene standards in our cloud kitchen. All meals are prepared fresh daily using quality-checked ingredients. Our kitchen team is trained in food safety protocols, and all packaging is hygienic and tamper-proof to ensure your meal reaches you safely.',
  },
  {
    q: 'Can I customize my meals?',
    a: 'Yes! Many of our dishes can be customized for spice level, portion size, and dietary preferences. You can mention your customization requirements in the order notes section of our app or call us directly at +91 81432 31857.',
  },
  {
    q: 'What is your delivery area?',
    a: 'We currently deliver to Miyapur, Kondapur, Madhapur, Gachibowli, Hafeezpet, and surrounding areas in Hyderabad. We are expanding rapidly — download our app and check live delivery coverage for your location.',
  },
  {
    q: 'How long does it take to receive an order?',
    a: 'Typical delivery time is 30–45 minutes depending on your location and order volume. For meal plan subscribers, deliveries are scheduled at your chosen time slot (Lunch: 12:00–2:00 PM, Dinner: 7:00–9:00 PM). You can track your delivery in real-time through the app.',
  },
  {
    q: 'What is your cancellation and refund policy?',
    a: 'Orders can be cancelled within 30 minutes of placement for a full refund. If you experience any issues with your order — incorrect items, quality concerns, or missing items — please contact us within 2 hours at customercare@digirasa.com or +91 81432 31857. Refunds are processed within 5–7 business days.',
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(null);

  return (
    <div className="policy-page faq-page">
      <div className="page-header">
        <div className="page-header-content">
          <div className="container">
            <h1>FAQ</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>FAQ</span>
            </div>
          </div>
        </div>
      </div>
      <section className="policy-content">
        <div className="container">
          <div className="policy-box">
            <h2>Frequently Asked Questions</h2>
            <p>Find quick answers to common questions about Digirasa.</p>
            <p>
              Our FAQ section is designed to help you easily understand how Digirasa works, what we
              offer, and how you can make the most of our food delivery service. It provides clear
              information on ordering, payments, delivery, and more—so you can get what you need
              without having to contact support.
            </p>
            <div className="faq-list">
              {faqs.map((item, i) => (
                <div key={i} className={`faq-item${open === i ? ' faq-item--open' : ''}`}>
                  <button
                    className="faq-item__question"
                    onClick={() => setOpen(open === i ? null : i)}
                  >
                    <span>{item.q}</span>
                    <span className="faq-item__icon">{open === i ? '−' : '+'}</span>
                  </button>
                  {open === i && (
                    <div className="faq-item__answer">
                      <p>{item.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="faq-contact">
              <p>
                Still have questions? <Link to="/contact">Contact Us</Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <AppDownloadSection />
    </div>
  );
};

export default FAQ;
